module.exports = __webpack_public_path__ + "img/blue_stripes_bg.84185b95.png";